var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21369_1011)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21369_1011",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7333 11.6729L10.8892 8.02734H9.11133L9.27116 11.6729H10.7333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32269 14.3644C9.51177 14.5508 9.73819 14.644 10.0019 14.644C10.1724 14.644 10.3294 14.6014 10.4733 14.5161C10.6171 14.4283 10.7329 14.3124 10.8209 14.1686C10.9114 14.0221 10.958 13.861 10.9607 13.6852C10.958 13.4242 10.8608 13.2005 10.669 13.014C10.4773 12.8276 10.2549 12.7344 10.0019 12.7344C9.73819 12.7344 9.51177 12.8276 9.32269 13.014C9.1336 13.2005 9.04044 13.4242 9.04302 13.6852C9.04044 13.9489 9.1336 14.1752 9.32269 14.3644Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.37793 17.4987H19.6229L10.0004 0.832031L0.37793 17.4987ZM10.0004 4.16536L3.26468 15.832H16.7362L10.0004 4.16536Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21369_1011)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#805C00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21369_1011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangle);
export default __webpack_public_path__ + "static/media/exclamationTriangle.62e74e92a61573abd64ed5ef892865ad.svg";
export { ForwardRef as ReactComponent };